export const firebaseConfig = {
  apiKey: "AIzaSyAmX_fWvaKIzvWTVX5fPi0DZutilqk5Ves",
  authDomain: "spacex-starter.firebaseapp.com",
  projectId: "spacex-starter",
  storageBucket: "spacex-starter.appspot.com",
  messagingSenderId: "273623866803",
  appId: "1:273623866803:web:34670952a6e89e466e7fc6",
};
